import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Popconfirm, Button } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {
  createResource,
  deleteResource,
  fetchResource,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
} from '../../appRedux/actions/FuelAdjustment';

import { fetchFilter } from "../../appRedux/actions";
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods';

import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';


export class FuelAdjustment extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({ visibleColumns: columns }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;
    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {
      if (item === '_id') {
        return;
      }
      if (selectedColumns.indexOf(item) === -1) {
        return;
      }
      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Attachments',
      key: 'attachments',
      render: (record) => (
        <div>
          {(record.attachments || []).length === 0 ? '-' :
            (record.attachments || []).map((a, i) => (
              <div key={i}>
                {a && a.path
                  ? <a href={a.path} target="_blank" rel="noopener noreferrer">{a.name || `file-${i + 1}`}</a>
                  : <span>{a && a.name}</span>}
              </div>
            ))}
        </div>
      ),
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          {/* Fuel adjustments can be deleted but never edited. */}
          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={() => {
              return <Popconfirm
                title="Are you sure you want to delete this record? The bowser balance will be recalculated."
                onConfirm={() => this.deleteResource(record._id)}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" size='small'>Delete</Button>
              </Popconfirm>
            }} />
        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  clearAll = () => {
    const clearQueryState = {
      sort: { field: '', order: '' },
      pagination: { pageSize: 10, current: 1 },
      filters: {},
    };
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
    window.location.reload(false);
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => (column.title !== "Action" && column.title !== "Attachments") && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "FuelAdjustment");
  }

  render() {
    const { match, data, loading, filters, modules, authUser, resourceName } = this.props;
    const { columns, visibleColumns } = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>
      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            visibleColumn={visibleColumns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            downloadToCSV={this.downloadToCSV}
            title={resourceName}
            size={'middle'}
            create={this.create}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
          />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create
            filters={filters}
            modules={modules}
            title={'CREATE'}
            resource={resourceName}
            onSubmit={this.createResource}
            loading={loading}
            {...props}
          />
          } />
      </Switch>
    </div>)
  }

}

const mapStateToProps = ({ auth, fuelAdjustment, commonData }) => {
  return {
    authUser: auth.authUser,
    total: fuelAdjustment.total,
    data: fuelAdjustment.resources,
    resource: fuelAdjustment.resource,
    edit: fuelAdjustment.edit,
    query: fuelAdjustment.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules
  }
}

function mapDispatchToProps() {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(FuelAdjustment);
